import { render, staticRenderFns } from "./CustomerShortOrder.vue?vue&type=template&id=17fc603d&scoped=true&"
import script from "./CustomerShortOrder.vue?vue&type=script&lang=js&"
export * from "./CustomerShortOrder.vue?vue&type=script&lang=js&"
import style0 from "./CustomerShortOrder.vue?vue&type=style&index=0&id=17fc603d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fc603d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VLayout})
